import { z } from 'zod';

/** What the browser keeps per store (contract: `nucleus:docs:keys:<storeId>`). */
export const docsKeySchema = z.object({
  prefix: z.string(),
  key: z.string(),
  name: z.string(),
  createdAt: z.string(),
});

export type DocsKey = z.infer<typeof docsKeySchema>;

export const docsKeysSchema = z.array(docsKeySchema).catch([]);

const rememberedValueSchema = z.object({ value: z.string(), from: z.string() });

export type RememberedValue = z.infer<typeof rememberedValueSchema>;

/** The tab's playground session (contract: `nucleus:docs:session`). */
export const docsSessionSchema = z
  .object({
    customer: z
      .object({
        accessToken: z.string(),
        refreshToken: z.string(),
        email: z.string().nullable(),
      })
      .nullable()
      .catch(null),
    idempotency: z.object({ last: z.string().nullable() }).catch({ last: null }),
    remembered: z.record(z.string(), z.array(rememberedValueSchema)).catch({}),
    /** Payment calls asked for confirmation once this tab. */
    paymentConfirmed: z.boolean().catch(false),
  })
  .catch({ customer: null, idempotency: { last: null }, remembered: {}, paymentConfirmed: false });

export type DocsSession = z.infer<typeof docsSessionSchema>;
export type DocsCustomer = NonNullable<DocsSession['customer']>;
